export const APPOINTMENTS_MIXPANEL_EVENTS = {
  selfReschedule: {
    visited: 'Visited Reschedule Page (Self Service)',
    pickedDate: 'Picked Reschedule Date (Self Service)',
    confirmStep: 'Visited Confirm Reschedule Page (Self Service)',
    submitted: 'Submitted Reschedule (Self Service)',
  },
};
